import React from 'react';
import { CalendarDaysIcon, ExternalLinkIcon } from 'lucide-react';
export function RegistrationCallout() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3094">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3095">
        <div className="flex items-center gap-4 p-6 rounded-xl mb-12 shadow-sm" style={{
        backgroundColor: '#1e3d2f'
      }} data-id="element-3096">
          <CalendarDaysIcon size={24} className="flex-shrink-0" style={{
          color: '#c8a84b'
        }} data-id="element-3097" />
          <div className="flex-1" data-id="element-3098">
            <p className="text-sm mb-1" style={{
            color: '#a0c8b0',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3099">
              Ready to get certified?
            </p>
            <a href="https://www.fentonlakes.com/m7/37--nra-range-safety-officer-class.html" target="_blank" rel="noopener noreferrer" className="text-base font-semibold transition-colors hover:underline" style={{
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3100">
              Register for this Class — Click Here
            </a>
          </div>
          <ExternalLinkIcon size={20} className="flex-shrink-0" style={{
          color: '#a0c8b0'
        }} data-id="element-3101" />
        </div>
      </div>
    </div>;
}